function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  margin-bottom: 1.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  container: auto;\n  max-width: 72rem;\n  margin: 0 auto;\n  padding: 0.5rem 1rem;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { Heart, MessageSquare, Share2, Download } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
var ActionsContainer = styled.div(_templateObject(), function(props) {
    return props.theme.border;
}, function(props) {
    return props.theme.border;
});
var ActionsInner = styled.div(_templateObject1());
var ActionsWrapper = styled.div(_templateObject2());
var LeftActions = styled.div(_templateObject3());
var RightActions = styled.div(_templateObject4());
export var ProjectSocialActions = function(param) {
    var isLiked = param.isLiked, likeCount = param.likeCount, commentCount = param.commentCount, _param_isLoadingLike = param.isLoadingLike, isLoadingLike = _param_isLoadingLike === void 0 ? false : _param_isLoadingLike, onLike = param.onLike, onComment = param.onComment, onShare = param.onShare, onDownload = param.onDownload;
    return /*#__PURE__*/ React.createElement(ActionsContainer, null, /*#__PURE__*/ React.createElement(ActionsInner, null, /*#__PURE__*/ React.createElement(ActionsWrapper, null, /*#__PURE__*/ React.createElement(LeftActions, null, /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        size: "sm",
        onClick: onLike,
        disabled: isLoadingLike,
        leftIcon: /*#__PURE__*/ React.createElement(Heart, {
            className: "w-4 h-4 ".concat(isLiked ? 'fill-red-500 text-red-500' : '')
        })
    }, likeCount), /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        size: "sm",
        onClick: onComment,
        leftIcon: /*#__PURE__*/ React.createElement(MessageSquare, {
            className: "w-4 h-4"
        })
    }, commentCount), /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        size: "sm",
        onClick: onShare,
        leftIcon: /*#__PURE__*/ React.createElement(Share2, {
            className: "w-4 h-4"
        })
    }, "공유")), /*#__PURE__*/ React.createElement(RightActions, null, /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        size: "sm",
        onClick: onDownload,
        leftIcon: /*#__PURE__*/ React.createElement(Download, {
            className: "w-4 h-4"
        })
    }, "다운로드")))));
};
export default ProjectSocialActions;
